import { newsApi } from './api';
import {
    ALERT_DISMISS_ENDPOINT,
    ALERT_REVISION_ENDPOINT,
    ALERT_STORE_ENDPOINT,
    DRIVER_EDIT_ENDPOINT,
    GET_ALERT_ENDPOINT
} from "./apiConstant";

export const AlertService = newsApi.injectEndpoints({
    endpoints: (build) => ({
        getAlert: build.query({
            query: (id) => ({
                url: `${GET_ALERT_ENDPOINT}/${id}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: ['Driver'],
        }),
        addAlert: build.mutation({
            query: (form) => ({
                url: `${ALERT_STORE_ENDPOINT}`,
                method: 'POST',
                body: form,
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        editDriver: build.mutation({
            query: ({ id, newForm }) => ({
                url: `${DRIVER_EDIT_ENDPOINT}/${id}`,
                method: 'POST',
                body: newForm,
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        revisionDriver: build.mutation({
            query: (id) => ({
                url: `${ALERT_REVISION_ENDPOINT}/${id}/revision`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
        dismissDriver: build.mutation({
            query: (id) => ({
                url: `${ALERT_DISMISS_ENDPOINT}/${id}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Driver'],
        }),
    }),
    overrideExisting: false,
})

export const {
    useGetAlertQuery,
    useAddAlertMutation,
    useRevisionDriverMutation,
    // useEditDriverMutation,
    useDismissDriverMutation,
} = AlertService